module.exports = __webpack_public_path__ + "img/shareTips.e111315f.png";